import { postJson } from 'utils/http/postJson';

export type PostEventRsvpResponse = {
  rsvp: {
    updated: string;
    answer: string;
  };
};

type Args = {
  answer: string;
};

export function listingApiPostEventRsvp(
  eventId: string,
  { answer }: Args,
): Promise<PostEventRsvpResponse> {
  return postJson<PostEventRsvpResponse>(
    `/data/website/events/${eventId}/rsvp`,
    {
      answer,
    },
  );
}
